<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ "trips.activity.ncc" | translate }}</h2>
<ng-container *ngIf="form">
  <mat-dialog-content [formGroup]="form" class="dialog-content">
    <div class="grid-container">
      <!-- Name -->
      <!-- This field is read-only because you cannot change the name of the ncc -->

      <mat-form-field
        appearance="outline"
        class="mat-form-field-readonly span-2-cols"
      >
        <mat-label class="label-text-readonly">{{
          "nccs.ncc-name" | translate
        }}</mat-label>
        <input matInput formControlName="name" [readonly]="true" />
      </mat-form-field>

      <!-- Phone -->
      <input-phone formControlName="phone" [required]="true"></input-phone>

      <!-- Starting Point -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{
          "trips.activity.ncc-starting-point" | translate
        }}</mat-label>
        <input matInput formControlName="startingPoint" [required]="true" />
        <mat-error
          *ngIf="
            form.get('startingPoint')?.invalid &&
            form.get('startingPoint')?.touched
          "
        >
          {{ getLabelErrorMessage('startingPoint') | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Starting time -->
      <input-time
        formControlName="startTime"
        label="start-time"
        [required]="true"
      ></input-time>

      <!-- Arrival Point -->
      <mat-form-field appearance="outline" class="span-2-cols">
        <mat-label>{{
          "trips.activity.ncc-arrival-point" | translate
        }}</mat-label>
        <input matInput formControlName="arrivalPoint" [required]="true" />
        <mat-error
          *ngIf="
            form.get('arrivalPoint')?.invalid &&
            form.get('arrivalPoint')?.touched
          "
        >
          {{ getLabelErrorMessage('arrivalPoint') | translate }}
        </mat-error>
      </mat-form-field>

      <!-- End time Approx -->
      <input-time
        formControlName="endTime"
        label="end-time-approx"
        [required]="true"
      ></input-time>

      <!--  Price -->
      <input-monetary-amount
        appCombinedReadonly
        #totalPriceReadonly="appCombinedReadonly"
        [forbiddenRoles]="['ACCOUNTANT']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
        [required]="true"
        formControlName="totalPrice"
      ></input-monetary-amount>

      <!-- Description -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "description" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="description"
          maxlength="300"
          rows="3"
        ></textarea>
        <mat-hint
          >{{ form.get("description")?.value?.length || 0 }}/300</mat-hint
        >
      </mat-form-field>

      <!-- Disclaimer -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "disclaimer" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="disclaimer"
          maxlength="300"
          rows="3"
        ></textarea>
        <mat-hint
          >{{ form.get("disclaimer")?.value?.length || 0 }}/300</mat-hint
        >
      </mat-form-field>

      <!-- Notes -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "notes" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="notes"
          maxlength="500"
          rows="3"
        ></textarea>
        <mat-hint>{{ form.get("notes")?.value?.length || 0 }}/500</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-content">
    <button mat-button (click)="cancel()">{{ "cancel" | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!form.valid"
    >
      {{ "confirmation" | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>
